var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "splitters-list-container mt-4 pl-4 pr-4" },
    _vm._l(_vm.list, function(object, index) {
      return _c(
        "div",
        { key: index, staticClass: "pr-6 pl-4 splitters-list-wrapper" },
        [
          _c("Splitters", {
            attrs: {
              data: object,
              "fiber-colors": _vm.fiberColors,
              cables: _vm.cables,
              splitters: _vm.splitters
            },
            on: { "open-menu": _vm.openMenu }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56d91416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d91416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/SplittersList.vue
// module id = null
// module chunks = 